export const BULK_CALENDAR_CANCELLATION_WARNING_TEXT = {
    id: 'oe.meetings.bulkCalendarCancellationWarning',
    defaultMessage: 'This action will send <span>{count} Calendar cancellations</span> to attendees',
    description: 'Warning about calendar cancellations sent during bulk cancel/remove meetings',
};
